import React, { Component } from "react"

/* Components */
import { Card } from "@cuba-go/poker-ui"


/* THE POSITION CARD

   The dealer pulls it before anything else and counts round the table with it — ace one,
   jack eleven, queen twelve, king thirteen — starting at his own box. Wherever the count
   lands is where the deal begins. It belongs to nobody's hand and is never compared. */
class PositionCard extends Component {

    render = () => {

        const { card, startBox } = this.props

        const where = startBox === null || startBox === undefined ? null
            : startBox === -1 ? "с карт дилера" : `с бокса ${startBox + 1}`

        /* The place is held open before the card is pulled. It is the first card off the
           shoe, so without it the whole board shifts sideways the moment the round
           starts — and it is the one card whose absence a player would otherwise read as
           the table having nothing to show yet. */
        return (
            <div className="niu--position">
                <div className="niu--position-card">
                    {card ? <Card data={card.name} /> : <div className="niu--position-place" />}
                </div>
                {where ? <div className="niu--position-text">Раздача {where}</div> : null}
            </div>
        )
    }

}

export default PositionCard
